import {apiClient} from "@/state/modules/apiClient";
const controller = "CapVanBan";
export const actions = {
    async get({commit}) {
        return apiClient.get(controller +"/get-all");
    },
};
